export class SoundEntity {
    constructor(public name: string, public soundFilePath: string, public iconFilePath: String)
    {
    }
  }